
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class Tip extends Vue {
  @Prop({ required: false, type: Boolean })
  block: boolean;
  @Prop({ required: false, type: Boolean })
  html: boolean;

  private getHtml() {
    return this.$slots.default.reduce((acc, slot) => acc + slot.text, "");
  }
}
